import _regeneratorRuntime from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue";
import _imports_0 from '@/assets/images/activity/activity_img.png';
var _hoisted_1 = {
  class: "account-activity"
};
var _hoisted_2 = {
  class: "title"
};
var _hoisted_3 = {
  class: "text"
};
var _hoisted_4 = {
  key: 0,
  class: "list"
};
var _hoisted_5 = ["onClick"];
var _hoisted_6 = {
  class: "info"
};
var _hoisted_7 = {
  class: "name"
};
var _hoisted_8 = {
  class: "block"
};
var _hoisted_9 = {
  class: "block"
};
var _hoisted_10 = {
  class: "block"
};
var _hoisted_11 = {
  key: 1,
  class: "empty-text"
};
import SvgIcon from "../base/SvgIcon.vue";
import { ref } from "vue";
import { getOngoingActivity } from "@/api/activity";
import { ActivityTypeEnum } from "@/constant/activity";
import { useRouter } from "@/hooks/useRouter";
import { getSupplyId } from "@/utils/authUtil";
export default {
  __name: 'AccountActivity',
  setup: function setup(__props) {
    var _useRouter = useRouter(),
      routerPush = _useRouter.routerPush;
    var items = ref([]);
    var getData = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getOngoingActivity();
            case 2:
              res = _context.sent;
              if (res.isOK) {
                data = res.data.items || [];
                items.value = data.filter(function (item) {
                  return item.activity_type === ActivityTypeEnum.SHARING;
                });
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function getData() {
        return _ref.apply(this, arguments);
      };
    }();
    getData();
    function goHistory() {
      routerPush({
        name: "ActivityHistory"
      });
    }
    function goDetail(item) {
      if (item.activity_type === "sharing") {
        location.href = "".concat(window.location.origin, "/activity/").concat(getSupplyId(), "/share?id=").concat(item.activity_id, "&user_activity_id=").concat(item.user_activity_id);
      }
    }
    return function (_ctx, _cache) {
      var _component_van_count_down = _resolveComponent("van-count-down");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("activity")), 1), _createElementVNode("div", {
        class: "history",
        onClick: goHistory
      }, [_createTextVNode(_toDisplayString(_ctx.$t("history")) + " ", 1), _createVNode(SvgIcon, {
        class: "icon",
        name: "arrow_right",
        size: "16"
      })])]), items.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, function (item) {
        return _openBlock(), _createElementBlock("div", {
          key: item.user_activity_id,
          class: "item",
          onClick: function onClick($event) {
            return goDetail(item);
          }
        }, [_cache[2] || (_cache[2] = _createElementVNode("div", {
          class: "img"
        }, [_createElementVNode("img", {
          src: _imports_0,
          alt: ""
        })], -1)), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("countdownToCouponCollectionEvent")), 1), _createVNode(_component_van_count_down, {
          class: "time",
          time: item.user_activity_end_time,
          onFinish: getData
        }, {
          default: _withCtx(function (timeData) {
            return [_createElementVNode("span", _hoisted_8, _toDisplayString(timeData.hours > 9 ? timeData.hours : "0" + timeData.hours), 1), _cache[0] || (_cache[0] = _createElementVNode("span", {
              class: "colon"
            }, ":", -1)), _createElementVNode("span", _hoisted_9, _toDisplayString(timeData.minutes > 9 ? timeData.minutes : "0" + timeData.minutes), 1), _cache[1] || (_cache[1] = _createElementVNode("span", {
              class: "colon"
            }, ":", -1)), _createElementVNode("span", _hoisted_10, _toDisplayString(timeData.seconds > 9 ? timeData.seconds : "0" + timeData.seconds), 1)];
          }),
          _: 2
        }, 1032, ["time"])])], 8, _hoisted_5);
      }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.$t("thereAreNoOngoingActivity")), 1))]);
    };
  }
};